import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export class Sliders {

    constructor()
    {
        this.registerSliders(['.slider-1', '.slider-2'])
    }

    registerSliders(sliderClass)
    {
        if (!document.querySelector(sliderClass)) {
            return;
        }

        sliderClass.forEach(_class => {
            let sliders = document.querySelectorAll(_class)
            sliders.forEach((slider) => {
                let parameters = JSON.parse(slider.getAttribute('component-options'))
                let sliderParameters = this.initOptions(slider, parameters)
                this.initSlider(sliderParameters[0], sliderParameters[1])
            })
        })
    }

    initOptions(sliderElement, parameters)
    {
        let options = {};

        /** Modules */
        options = this.initModules(options, parameters)

        /** Common options */
        options = this.initCommonOptions(options, parameters)

        /** Autoplay */
        options = this.initAutoPlay(options, parameters)

        /** Pagination */
        options = this.initPagination(options, parameters)

        /** Navigation */
        options = this.initNavigation(options, parameters)

        /** Breakpoints */
        options = this.initBreakpoints(options, parameters)

        return [sliderElement, options]

    }

    initModules(options, parameters)
    {
        let activeModules = [];
        if (this.checkParameters('pagination', 'true', parameters)) {
            activeModules = [...activeModules, Pagination] }
        if (this.checkParameters('navigation', 'true', parameters)) {
            activeModules = [...activeModules, Navigation] }
        if (this.checkParameters('autoplay', 'true', parameters)) {
            activeModules = [...activeModules, Autoplay] }
        return {...options, modules : activeModules}
    }

    initAutoPlay(options, parameters)
    {
        if (!this.checkParameters('autoplay', 'true', parameters)) {
            return options
        }
        let autoplayValue = {
            disableOnInteraction : false,
        }
        autoplayValue.delay = parseInt(parameters['autoplay_delay'])
        return {...options, autoplay : autoplayValue}
    }

    initCommonOptions(options, parameters)
    {
        options = {...options, slidesPerView : parseInt(parameters['slides_per_views'])}
        options = {...options, speed : parseInt(parameters['speed'])}
        options = {...options, spaceBetween : parseInt(parameters['space_between'])}
        if (this.checkParameters('loop', 'true', parameters)) {
            options = {...options, centeredSlides : true}
        }
        if (this.checkParameters('loop', 'true', parameters)) {
            options = {...options, loop : true, loopFillGroupWithBlank : true}
        }
        if (this.checkParameters('draggable', 'true', parameters)) {
            options = {...options, grabCursor : true}
        }
        return options
    }

    initPagination(options, parameters)
    {
        if (this.checkParameters('pagination', 'true', parameters)) {
            let pagination = {
                el : '.swiper-pagination',
                clickable : true,
            }

            if (parameters['pagination-style'] === 'number-pagination') {
                pagination = {...pagination,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '">0' + (index + 1) + '</span>';
                    },
                }
            }

            if (parameters['pagination-style'] === 'lines-pagination') {
                pagination = {...pagination,
                    type: 'progressbar',
                }
            }

            options = {...options, pagination}
        }
        return options
    }

    initNavigation(options, parameters)
    {
        if (this.checkParameters('navigation', 'true', parameters)) {
            options = {...options,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }
        }
        return options
    }

    initBreakpoints(options, parameters)
    {

        let _breakpoints = {}

        _breakpoints['0'] = {
            slidesPerView: parseInt(parameters['mobile']['slides_numbers']),
            spaceBetween: parseInt(parameters['mobile']['space_between']),
        }

        _breakpoints[parameters['mobile']['max_width']] = {
            slidesPerView: parseInt(parameters['tablette']['slides_numbers']),
            spaceBetween: parseInt(parameters['tablette']['space_between']),
        }

        _breakpoints[parameters['tablette']['max_width']] = {
            slidesPerView: parseInt(parameters['slides_per_views']),
            spaceBetween: parseInt(parameters['space_between']),
        }

        options = {...options, breakpoints : _breakpoints}

        return options;
    }

    initSlider(sliderElement, options)
    {
        new Swiper(sliderElement, options)
    }

    checkParameters(key, value, json_array)
    {
        return (key in json_array && json_array[key] === value);
    }

}



// WEBPACK FOOTER //
// ./js/scripts/sliders.js